"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgViewTextCtl = /** @class */ (function (_super) {
    __extends(DlgViewTextCtl, _super);
    function DlgViewTextCtl() {
        return _super.call(this, true) || this;
    }
    DlgViewTextCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            visible: false,
            title: "",
            text: ""
        };
    };
    DlgViewTextCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgViewTextCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgViewTextCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgViewTextCtl.prototype.SetText = function (val) {
        this.DATA.text = val;
        this.Update();
        return this;
    };
    DlgViewTextCtl.prototype.SetTitle = function (val) {
        this.DATA.title = val;
        this.Update();
        return this;
    };
    DlgViewTextCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    return DlgViewTextCtl;
}(BaseController_1.BaseController));
exports.DlgViewTextCtl = DlgViewTextCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgViewTextCtl.ts
// module id = 888
// module chunks = 0